// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"110":"98a0ee05","835":"f700c8fe"}[chunkId] + ".chunk.css";
};